import { initI18n, resources as sharedResources } from '@intellimon/shared/i18n';

// English translations
import authEn from './locales/en/auth.json';
import dashboardEn from './locales/en/dashboard.json';
import sitesEn from './locales/en/sites.json';
import millsEn from './locales/en/mills.json';
import lifterBarsEn from './locales/en/lifterBars.json';
import coordinatorsEn from './locales/en/coordinators.json';
import sensorsEn from './locales/en/sensors.json';
import usersEn from './locales/en/users.json';
import profileEn from './locales/en/profile.json';
import navigationEn from './locales/en/navigation.json';
import rawReadingsEn from './locales/en/rawReadings.json';
import oreTypesEn from './locales/en/oreTypes.json';

// Turkish translations
import authTr from './locales/tr/auth.json';
import dashboardTr from './locales/tr/dashboard.json';
import sitesTr from './locales/tr/sites.json';
import millsTr from './locales/tr/mills.json';
import lifterBarsTr from './locales/tr/lifterBars.json';
import coordinatorsTr from './locales/tr/coordinators.json';
import sensorsTr from './locales/tr/sensors.json';
import usersTr from './locales/tr/users.json';
import profileTr from './locales/tr/profile.json';
import navigationTr from './locales/tr/navigation.json';
import rawReadingsTr from './locales/tr/rawReadings.json';
import oreTypesTr from './locales/tr/oreTypes.json';

const tenantResources = {
  en: {
    ...sharedResources.en,
    auth: authEn,
    dashboard: dashboardEn,
    sites: sitesEn,
    mills: millsEn,
    lifterBars: lifterBarsEn,
    coordinators: coordinatorsEn,
    sensors: sensorsEn,
    users: usersEn,
    profile: profileEn,
    navigation: navigationEn,
    rawReadings: rawReadingsEn,
    oreTypes: oreTypesEn,
  },
  tr: {
    ...sharedResources.tr,
    auth: authTr,
    dashboard: dashboardTr,
    sites: sitesTr,
    mills: millsTr,
    lifterBars: lifterBarsTr,
    coordinators: coordinatorsTr,
    sensors: sensorsTr,
    users: usersTr,
    profile: profileTr,
    navigation: navigationTr,
    rawReadings: rawReadingsTr,
    oreTypes: oreTypesTr,
  },
};

// Initialize i18n with tenant portal translations
const i18n = initI18n(tenantResources);

export default i18n;
